import { Typography, useTheme } from "@mui/material";
import FlexBetween from "components/FlexBetween";
import WidgetWrapper from "components/WidgetWrapper";

const AdvertWidget = () => {
  const { palette } = useTheme();
  const dark = palette.neutral.dark;
  const main = palette.neutral.main;
  const medium = palette.neutral.medium;

  return (
    <WidgetWrapper>
      <FlexBetween>
        <Typography color={dark} variant="h5" fontWeight="500">
          Sponsored
        </Typography>
        <Typography color={medium}>Create Ad</Typography>
      </FlexBetween>
      <img
      crossOrigin="anonymous"
        width="100%"
        height="auto"
        alt="advert"
        src='/Advertisement.jpeg'
        style={{ borderRadius: "0.75rem", margin: "0.75rem 0" }}
      />
      <FlexBetween>
        <Typography color={main}>Tattoo Promotion</Typography>
        <Typography color={medium}>tattoo@tattoo.com</Typography>
      </FlexBetween>
      <Typography color={medium} m="0.5rem 0">
     This is an advertisement for a tattoo artist that specializes in traditional japanese tattoos and he likes tattoos
      </Typography>
    </WidgetWrapper>
  );
};

export default AdvertWidget;